import IncidentsTable from "./incidentTable";
import { IncidentsSideModal } from "./incidentSideModal";
import ChatBotButton from "./searchAgent/chatbot";
import SearchAgentSuite from "./searchAgent/agenticChat";
import { ChatbotProvider } from "./searchAgent/chatBotContext";
import { SocAiAgent } from "./newSearchAgent/socaiAgent";
import SummarySidePanel from "./summarySidebar/summarySidePanel";

export interface ISortData {
  field: string;
  order: number;
}

export interface ShowMoreState {
  [key: string]: boolean;
}

/**
 * This component tries to separate out the related components
 * that do not have to do with the Redux list of alerts and 
 * those that do, this is so that only the affected components
 * are refreshed when data is added or changed.
 * @returns 
 */
export const Incidents: () => JSX.Element = () => {
  return (
    <div className="h-full overflow-hidden" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* The more information modal */}
      <ChatbotProvider>
      {/* <IncidentsSideModal /> */}
      
      {/* All data tied to the Redux list of alerts */}
      <IncidentsTable />
      <SocAiAgent/>
      <ChatBotButton />  
      </ChatbotProvider>
    </div>
  );
};